import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-345ba44f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "card-header__left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header__title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "利用分の請求先一覧"),
  /*#__PURE__*/_createElementVNode("span", null, " + 2024年3月(2月末日を含む、3月末日は含まない)に更新期日を迎える年次契約の請求 ")
], -1))


import { ISelectOption } from "@/models/select-option";
import Select from "@/components/common/form/Select.vue";
import Btn from "@/components/common/Btn.vue";

interface IProps {
  selectedYearMonth: string;
  yearMonthList: ISelectOption[];
  changeSelectedYearMonth: (e: Event) => void;
  exportCsv: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardHeader',
  props: {
    selectedYearMonth: {},
    yearMonthList: {},
    changeSelectedYearMonth: { type: Function },
    exportCsv: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Select, {
        "model-value": _ctx.selectedYearMonth,
        onChange: _ctx.changeSelectedYearMonth,
        options: _ctx.yearMonthList,
        class: "date-select"
      }, null, 8, ["model-value", "onChange", "options"]),
      _hoisted_3
    ]),
    _createVNode(Btn, {
      text: "CSV出力",
      "btn-type": "btn-gray",
      "on-click-event": _ctx.exportCsv
    }, null, 8, ["on-click-event"])
  ]))
}
}

})